import React, { useEffect, useRef, useState } from "react";
import axios from '../../utils/axiosConfig';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Webcam from "react-webcam";
import { isBlankFrame } from "../../utils/blankFrame";
import msgConstants from '../../utils/messages';
import Dialog from '@mui/material/Dialog';
import { Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import VideocamIcon from '@mui/icons-material/Videocam';
import MicIcon from '@mui/icons-material/Mic';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Transition, { createSafeTransitionHandlers } from './Transition';
import noMicrophone from './../../assets/noMic.png';
import AudioTest from "../MediaTestModal";
import { PROCTORING_CAMERA_CONSTRAINTS, ANALYSIS_FRAME_LONG_SIDE } from "../../utils/sharedCamera";


const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    margin: 0,
    minWidth: "100%",
    minHeight: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
  },
  wrapper: {
    display: "flex",
    height: "100%",
    width: "100%",
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(4),
    },
  },
  Errwrapper: {
    display: "flex",
    height: "100%",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(4),
    },
  },
  leftColumn: {
    [theme.breakpoints.down("md")]: {
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      margin: 0,
    },
  },
  rightColumn: {
    flex: 1,
    marginRight: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  TopRightColumn: {
    flex: 1,
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "15px",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  ErrleftColumn: {
    flex: 1,
    marginLeft: theme.spacing(13),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  ErrrightColumn: {
    flex: 1,
    paddingLeft: theme.spacing(20),
    paddingRight: theme.spacing(15),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  leftside: {
    alignItems: "center",
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(6),
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(6),
    },
  },
  background1: {
    backgroundColor: "#BAD3DD",
    padding: theme.spacing(2),
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(4),
    width: "80%",
  },
  background2: {
    backgroundColor: "#BAD3DD",
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    width: "70%",
    [theme.breakpoints.down("md")]: {
      width: "90%",
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      margin: 0,
    },
  },
  webbox: {
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(1),
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      margin: 0,
    },
  },
  box: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      width: "90%",
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      margin: 0,
    },
  },
  Errbox: {
    backgroundColor: "#F2FFD4",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    marginRight: theme.spacing(8),
    marginLeft: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
    border: "2px solid #CCFF54",
  },
  setup: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(1),
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      margin: 0,
    },
  },
  rightsetup: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(5),
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(5),
      margin: 0,
    },
  },
  Camera: {
    marginTop: theme.spacing(1),
  },
  WebCAM: {
    marginTop: theme.spacing(1),
  },
  errWebCAM: {
    marginLeft: theme.spacing(12),
  },
  errWebCAMPara: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2),
    fontSize: "14px",
    wordSpacing: "2px",
    lineHeight: "1.5",
  },
  audiobottombutton: {
    marginTop: theme.spacing(2),
  },
  captureBTN: {
    marginRight: theme.spacing(10),
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(1),
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      margin: 0,
    },
  },
  BTN: {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  accessmic: {
    marginLeft: theme.spacing(4),
    width: "80%",
  },
  browser: {
    color: "#51869B",
  },
  waitMSG: {
    textAlign: "center",
    fontSize: "22px",
    marginTop: theme.spacing(40),
  },
  clickAgain: {
    marginLeft: theme.spacing(20),
  },
  clickAgainTXT: {
    marginTop: theme.spacing(20),
    marginLeft: theme.spacing(4),
    width: "100%",
  },
  weberror: {
    backgroundColor: "#CC0000",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "40%",
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: "#ffffff",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  micerror: {
    backgroundColor: "#CC0000",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "40%",
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: "#ffffff",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  img: {
    marginLeft: theme.spacing(1),
  },
  status: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(14),
  },
  leftstatus: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(20),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
      marginRight: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
      marginRight: 0,
    },
  },
  noMicContainer: {
    [theme.breakpoints.down("md")]: {
      width: "50%",
      height: "50%",
      marginTop: theme.spacing(5),
      marginLeft: "auto",
    },
  },
  nomic: {
    textAlign: "center",
    marginTop: "4vh",
  },
  micimage: {
    marginTop: "10vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      width: "70%",
      height: "auto",
      marginTop: "5vh",
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  detectImageContainer: {
    marginTop: theme.spacing(7),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  detectImage: {
    maxWidth: "100%",
    maxHeight: "400px",
  },
  camscreen: {
    width: "100%",
    height: "auto",
    maxWidth: 550,
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
}));

// Fixed FadeTransition for Snackbar to prevent null node errors
// Uses Fade instead of Grow since Fade doesn't access scrollTop
// Uses the shared createSafeTransitionHandlers from Transition.js
const FadeTransition = React.forwardRef(function FadeTransition(props, ref) {
  const { onEnter: _onEnter, onEntering: _onEntering, onEntered: _onEntered, onExit: _onExit, onExiting: _onExiting, onExited: _onExited, ...otherProps } = props;
  const handlers = createSafeTransitionHandlers(props);

  return (
    <Fade
      ref={ref}
      {...otherProps}
      onEnter={handlers.handleEnter}
      onEntering={handlers.handleEntering}
      onEntered={handlers.handleEntered}
      onExit={handlers.handleExit}
      onExiting={handlers.handleExiting}
      onExited={handlers.handleExited}
    />
  );
});

// After this many consecutive system-side failures (model not ready / analysis error -
// never counts a genuine no-face/multi-face result), stop offering "Click Again" against
// a server that keeps failing the same way and tell the candidate to switch devices
// instead, so they're never stuck retrying forever with no way out.
const SYSTEM_ERROR_RETRY_LIMIT = 3;
// Reference photo capture: same camera request as the exam's own proctoring camera, and saved at
// the same size as the analysed exam photos (utils/sharedCamera.js). The Webcams also need
// forceScreenshotSourceSize: without it react-webcam snapshots at the preview's on-screen width
// (550 px on a laptop, ~165 px on a phone) instead of the camera's resolution.
const REFERENCE_CAMERA_CONSTRAINTS = PROCTORING_CAMERA_CONSTRAINTS.video;
const REFERENCE_LONG_SIDE = ANALYSIS_FRAME_LONG_SIDE;
// Motion check (video backend liveFrames.js motionOf, logged only): the last MOTION_FRAMES camera
// pictures before the photo, MOTION_FRAME_MS apart, go with it as motionFrames. A real person moves a
// little or blinks; a photo held up to the camera doesn't. Nothing to do for the candidate, no wait.
// Same size as the photo: at 640 px the face mesh was noisy enough for a flat photo to come close
// to "moved" (0.036 against the 0.04 bar; 0.008 at 960 px).
const MOTION_FRAMES = 3;
const MOTION_FRAME_MS = 500;
const MOTION_LONG_SIDE = REFERENCE_LONG_SIDE;

function ImagEProctoringCapture(props) {
  const classes = useStyles();
  const webcamRef = useRef(null);

  // micNeeded: the test has audio / video / speaking questions or speaker monitoring (Instruction.jsx).
  const { examDetail, hidden, setHidden, resumeTest, MonitoringData, micNeeded } = props;
  const _closeInstruction = () => {
    window.location.reload(false);
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [snapShow, setSnapShow] = React.useState(true);
  // Resume identity notice (see verifyResumeIdentity below).
  const [resumeIdentityNotice, setResumeIdentityNotice] = React.useState(false);
  const [_open, setOpen] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [_countFace, setCountFace] = React.useState(0);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [capturedImage, setCapturedImage] = React.useState(null);
  const motionFramesRef = useRef([]);
  const [_inCaptureMode, setInCaptureMode] = React.useState(false);
  const [showProceedButton, setShowProceedButton] = React.useState(false);
  const [_facedetected, setfacedetected] = React.useState(false);
  const [ClickAgain, setClickAgain] = React.useState(false);
  const [ShowClickAgainButton, setShowClickAgainButton] = React.useState(false);
  const [StartCapture, setStartCapture] = React.useState(true);
  const [ShowCaptureImageButton, setShowCaptureImageButton] = React.useState(false);
  const [_webcamReady, setWebcamReady] = React.useState(false);
  const [WaitingMessage, setWaitingMessage] = React.useState(null);
  const [Nofaces, setNofaces] = React.useState(false);
  // The camera sent no picture (placeholder frame): its own message, not "come closer".
  const [cameraBlank, setCameraBlank] = React.useState(false);
  // Still no picture after CAMERA_BLANK_RETAKES tries: tell them the camera can't be used here.
  const [cameraUnavailable, setCameraUnavailable] = React.useState(false);
  const [Multiplefaces, setMultiplefaces] = React.useState(false);
  const [notFacingCamera, setNotFacingCamera] = React.useState(false);
  const [handObstruction, setHandObstruction] = React.useState(false);
  const [faceOccluded, setFaceOccluded] = React.useState(false);
  // Hand over the face (video backend hand check): a retake, at most UNCLEAR_RETAKES times - then
  // the photo is accepted and saved for reviewers, so a candidate is never stuck here.
  const handRetakesRef = useRef(0);
  // Unclear face in the reference photo (covered, masked, too dark): ask for a retake, at most
  // UNCLEAR_RETAKES times - then accept the photo, so nobody is stuck here.
  const [faceUnclear, setFaceUnclear] = React.useState(false);
  const unclearRetakesRef = useRef(0);
  const occludedRetakesRef = useRef(0);
  const UNCLEAR_RETAKES = 2;
  // Camera sends no picture: never accepted - a test without a single usable photo can't be
  // proctored (production 27 Oct 2026: 7 of 10 accepted blank cameras finished with no usable photo,
  // HDFC aborted 2 for face not found 12-20 min in). From the CAMERA_BLANK_RETAKES-th blank photo the
  // candidate is told the camera can't be used (no permission or a camera fault) and to change device.
  const blankRetakesRef = useRef(0);
  const CAMERA_BLANK_RETAKES = 3;
  // Reference photo that is a photo of a person (on a screen, printed) held up to the camera -
  // the video backend's liveness check (REFERENCE_LIVENESS_MODE=enforce) sets spoof_suspected and
  // says how many retakes to ask for (spoof_retakes). After those the photo is accepted and saved
  // as a 'referenceSpoof' photo for reviewers, so a genuine candidate wrongly flagged isn't stuck.
  const [spoofSuspected, setSpoofSuspected] = React.useState(false);
  const spoofRetakesRef = useRef(0);
  // Someone else in view but too small or cut off to count as a second face (video backend
  // other_person_in_view): one retake asking for only the candidate in view, then the photo is
  // accepted and saved as 'referenceOtherPerson' for reviewers - a shared room must never stop them.
  const otherPersonRetakesRef = useRef(0);
  const OTHER_PERSON_RETAKES = 1;
  const [SystemNotReady, setSystemNotReady] = React.useState(false);
  const [DeviceNotSupported, setDeviceNotSupported] = React.useState(false);
  const consecutiveSystemErrorsRef = useRef(0);
  const [WebCamError, setWebCamError] = React.useState(false);
  const [MicError, setMicError] = React.useState(false);
  const [ObjectsDetected, setObjectsDetected] = React.useState(false);
  const [_ObjectNames, setObjectNames] = React.useState([]);
  const [_Closed, setClosed] = React.useState(false);
  const [MediaErrorModal, setMediaErrorModal] = React.useState(true);
  const [CameraTroubleshoot, setCameraTroubleshoot] = React.useState(false);
  const [MicTroubleshoot, setMicTroubleshoot] = React.useState(false);
  // Test types 14/15: the microphone test only when the test needs a microphone, else straight to the camera.
  const [testingStage, setTestingStage] = useState(micNeeded ? "mic" : "camera");
  const [processing, setProcessing] = useState(false);
  const [proctoringImageAnalysisLogId, setProctoringImageAnalysisLogId] = useState(null);

  const _handleClick = () => {
    setOpen(true);
  };

  // Speaker monitoring: check the microphone once when the setup opens, then release it (this ran on
  // every render before and never stopped the microphones it opened).
  const speakerMonitoring = !!(MonitoringData && MonitoringData.result && MonitoringData.result.speaker_dialect);
  React.useEffect(() => {
    if (!modalOpen || !examDetail[0].monitoringflag || !speakerMonitoring) return undefined;
    let cancelled = false;
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop());
        if (!cancelled) setMicError(false);
      })
      .catch(() => {
        if (!cancelled) setMicError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [modalOpen, examDetail, speakerMonitoring]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return false;
    }
    setModal(false);
  };

  const startCapture = () => {
    setModalOpen(true);
  };

  const reduceImageSize = async (imageSrc) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const reducedImage = canvas.toDataURL("image/jpeg", 0.8);
        resolve(reducedImage);
      };
      img.src = imageSrc;
    });
  };

  // The reference photo every exam photo is compared against. Captured at up to 1280x720 (was
  // 450x300, which left too little of the face to match reliably) and saved as a JPEG of at most
  // REFERENCE_LONG_SIDE px, the same size as the exam photos - a PNG at this size would be 1-2 MB
  // in localStorage.
  const toReferenceJpeg = (dataUrl) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, REFERENCE_LONG_SIDE / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.9));
      };
      img.onerror = () => resolve(dataUrl);
      img.src = dataUrl;
    });

  // BACKEND API FACE DETECTION - NO FRONTEND MODELS
  const captureImage = async () => {
    setProcessing(true);
    setShowClickAgainButton(false);

    if (ClickAgain === false) {
      setWaitingMessage(msgConstants.WAIT_MSG);
    }

    const motionFrames = motionFramesRef.current.slice();
    const imageSrc = await toReferenceJpeg(webcamRef.current.getScreenshot());
    setCapturedImage(imageSrc);

    try {
      // Proxied through v2-user-backend (not called directly) so the
      // face-analysis microservice credential stays server-side — see
      // faceAnalysisProxy.js. Also sidesteps the cross-origin credential
      // issue the old direct call worked around (video-backend's CORS
      // returns ACAO:* which rejects credentialed requests) since this is
      // now a same-origin call using our normal HttpOnly auth cookie.
      const response = await axios.post(
        `/test/proctoring/single-face`,
        {
          primaryImage: imageSrc.split(",")[1],
          userexamid: examDetail[0].id,
          // The test's phone detection setting: when on, a phone in the reference photo is caught.
          objectDetection: MonitoringData?.result?.object_detection === true,
          ...(motionFrames.length ? { motionFrames } : {}),
          // The browser's name for the camera: logged with the photo (virtual camera apps are marked for review).
          cameraLabel: webcamRef.current?.stream?.getVideoTracks?.()[0]?.label || null,
        }
      );

      const { proctoringImageAnalysisLogId, face_detected, multiple_faces, face_count, not_facing_camera, hand_obstruction, face_occluded, object_detected, object_names, face_unclear, spoof_suspected, spoof_retakes, retake_counts, camera_blank, other_person_in_view } = response.data;
      // Retakes already asked for in this sitting, counted by the server from the stored attempts, so a
      // page reload doesn't reset them (as in GenAI interviews and AH Proctor). This page's own counts
      // only when the server didn't send them.
      const retakesSoFar = (reason, local) => (retake_counts && Number.isInteger(retake_counts[reason]) ? retake_counts[reason] : local);
      setProctoringImageAnalysisLogId(proctoringImageAnalysisLogId);
      console.log({
        proctoringImageAnalysisLogId,
        face_detected,
        multiple_faces,
        face_count,
        not_facing_camera,
        hand_obstruction,
        face_occluded,
        object_detected,
        object_names,
        face_unclear,
        spoof_suspected,
        spoof_retakes
      })
      // Half face / out of frame, too dark, too small (the face gate's reasons) can always be fixed by the
      // candidate: retake with no limit. Only a low face-mesh score alone is accepted after the retakes.
      const gateRetake = ["out_of_frame", "too_dark", "too_small"].includes(response.data.face_gate && response.data.face_gate.reason);
      const askRetakeUnclear = face_count === 1 && face_unclear === true && (gateRetake || retakesSoFar("face_unclear", unclearRetakesRef.current) < UNCLEAR_RETAKES);
      // Face covered: like hand over the face - retakes, then accepted for review.
      const askRetakeOccluded = face_count === 1 && face_occluded === true && retakesSoFar("face_occluded", occludedRetakesRef.current) < UNCLEAR_RETAKES;
      const acceptedDespiteUnclear = face_unclear === true && !askRetakeUnclear;
      const acceptedDespiteOccluded = face_occluded === true && !askRetakeOccluded;
      const spoofRetakes = Number.isInteger(spoof_retakes) ? spoof_retakes : 2;
      const askRetakeSpoof = face_count === 1 && spoof_suspected === true && spoofRetakesRef.current < spoofRetakes;
      const acceptedDespiteSpoof = spoof_suspected === true && !askRetakeSpoof;
      const askRetakeHand = face_count === 1 && hand_obstruction === true && retakesSoFar("hand_obstruction", handRetakesRef.current) < UNCLEAR_RETAKES;
      const acceptedDespiteHand = hand_obstruction === true && !askRetakeHand;
      const askRetakeOtherPerson = face_count === 1 && other_person_in_view === true && otherPersonRetakesRef.current < OTHER_PERSON_RETAKES;
      const acceptedDespiteOtherPerson = other_person_in_view === true && !askRetakeOtherPerson;
      console.log({
        UNCLEAR_RETAKES,
        unclearRetakesRef: unclearRetakesRef.current,
        askRetakeUnclear,
        spoofRetakesRef: spoofRetakesRef.current,
        spoofRetakes,
        handRetakesRef: handRetakesRef.current,
        askRetakeSpoof,
        acceptedDespiteSpoof,
        askRetakeHand,
        acceptedDespiteHand
      })

      // Reset all warning states
      setNofaces(false);
      setCameraBlank(false);
      setCameraUnavailable(false);
      setMultiplefaces(false);
      setNotFacingCamera(false);
      setHandObstruction(false);
      setFaceOccluded(false);
      setFaceUnclear(false);
      setSpoofSuspected(false);
      setObjectsDetected(false);
      setObjectNames([]);
      setSystemNotReady(false);
      // A response came back at all, so the system isn't broken - reset the streak.
      consecutiveSystemErrorsRef.current = 0;

      // Check for face detection issues
      if (!face_detected || face_count === 0) {
        if (camera_blank === true) {
          // Blank photos before this one (server count, so a reload doesn't reset it).
          const blanksBefore = retakesSoFar("camera_blank", blankRetakesRef.current);
          blankRetakesRef.current += 1;
          setCameraUnavailable(blanksBefore + 1 >= CAMERA_BLANK_RETAKES);
        }
        setNofaces(true);
        setCameraBlank(camera_blank === true);
      } else if (multiple_faces || face_count >= 2) {
        setMultiplefaces(true);
      } else if (face_count === 1) {
        // Face detected, check for objects
        if (object_detected && object_names && object_names.length > 0) {
          setObjectsDetected(true);
          setObjectNames(object_names);
        } else if (askRetakeSpoof) {
          spoofRetakesRef.current += 1;
          setSpoofSuspected(true);
        } else if (askRetakeUnclear) {
          unclearRetakesRef.current += 1;
          setFaceUnclear(true);
        } else if (not_facing_camera) {
          // A hand or mask over the face also reads as "not facing the camera"; when the face is
          // unclear, say what to fix (remove the hand) rather than "look at the camera".
          if (face_unclear === true) setFaceUnclear(true);
          else setNotFacingCamera(true);
        } else if (askRetakeHand) {
          handRetakesRef.current += 1;
          setHandObstruction(true);
        } else if (askRetakeOccluded) {
          occludedRetakesRef.current += 1;
          setFaceOccluded(true);
        } else if (askRetakeOtherPerson) {
          // Shown with the "only you in view" message of a second face.
          otherPersonRetakesRef.current += 1;
          setMultiplefaces(true);
        } else {
          // No objects detected - attempt to save. "Proceed" only unlocks and
          // this modal only closes once the save actually succeeds; a failed
          // save must not let the candidate continue without a persisted
          // primary photo.
          await acceptReferencePhoto(imageSrc, [
            [acceptedDespiteUnclear, "faceNotClear"],
            [acceptedDespiteOccluded, "faceCovered"],
            [acceptedDespiteHand, "handObstruction"],
            [acceptedDespiteSpoof, "referenceSpoof"],
            [acceptedDespiteOtherPerson, "referenceOtherPerson"],
          ].filter(([accepted]) => accepted).map(([, tag]) => tag));
        }
      }

      // Show warning if there are issues
      if (face_count === 0 || face_count >= 2 || not_facing_camera || askRetakeHand || askRetakeOccluded || askRetakeOtherPerson || askRetakeSpoof || askRetakeUnclear || (object_detected && object_names && object_names.length > 0)) {
        setWaitingMessage(null);
        setClickAgain(true);
        setShowClickAgainButton(true);
        setHidden(false);
      }
    } catch (error) {
      console.error("Error in facial analysis:", error);
      setWaitingMessage(null);
      setClickAgain(true);
      setShowClickAgainButton(true);
      setHidden(false);

      // The proxy forwards the microservice's structured 503 body when it couldn't
      // actually analyze the image (model still loading, etc.) - distinct from a normal
      // face_detected:false result. Tell the candidate this isn't about their camera,
      // instead of showing a generic error that implies something's wrong on their end.
      const errorCode = error?.response?.data?.error_code;
      // Our side failed (model not ready, analysis error, timeout, gateway error) - not the candidate's.
      const serviceFailed = errorCode === "MODEL_NOT_READY" || errorCode === "ANALYSIS_ERROR" || !error?.response || error.response.status >= 500;
      if (serviceFailed) {
        consecutiveSystemErrorsRef.current += 1;
        setNofaces(false);
        setMultiplefaces(false);
        setNotFacingCamera(false);
        setHandObstruction(false);
        setFaceOccluded(false);
        setFaceUnclear(false);
        setObjectsDetected(false);
        if (consecutiveSystemErrorsRef.current >= SYSTEM_ERROR_RETRY_LIMIT && (await isBlankFrame(imageSrc))) {
          // The check service is down, but this browser can see the camera sends no picture: a
          // blank camera is never accepted (user, 28 Oct 2026) - the same blank-camera messages.
          setSystemNotReady(false);
          blankRetakesRef.current += 1;
          setCameraUnavailable(blankRetakesRef.current >= CAMERA_BLANK_RETAKES);
          setCameraBlank(true);
          setNofaces(true);
        } else if (consecutiveSystemErrorsRef.current >= SYSTEM_ERROR_RETRY_LIMIT) {
          // The check service is down: never the candidate's problem. Accept the photo unchecked,
          // keep it flagged for reviewers, and let the candidate continue.
          setSystemNotReady(false);
          setShowClickAgainButton(false);
          setClickAgain(false);
          await acceptReferencePhoto(imageSrc, ["faceCheckUnavailable"]);
        } else {
          setSystemNotReady(true);
        }
      } else {
        setMessage("Error during facial analysis.");
        setModal(true);
      }
    }

    setProcessing(false);
  };


  // Saves an accepted reference photo and lets the candidate proceed. `reviewTags`: photos kept for
  // reviewers as well (accepted after retakes, or accepted unchecked because the check service was down).
  const acceptReferencePhoto = async (imageSrc, reviewTags = []) => {
    setfacedetected(true);
    // Resume (exam already started): the photo taken at the start stays the reference - keep
    // it in localStorage and compare this one with it (the server stores this one beside it).
    const isResume = examDetail[0].status !== "000";
    if (!isResume) localStorage.setItem("primaryimage", imageSrc);
    const primaryimage = await reduceImageSize(imageSrc);
    // Error "R" = for review ("N" would be recorded as a no-face photo). Never blocks the candidate.
    reviewTags.forEach((phototag) =>
      axios
        .post("/test/saveErrorImage", {
          userid: examDetail[0].userid,
          userexamid: examDetail[0].id,
          facecount: 1,
          error: "R",
          imagePath: primaryimage,
          expression1: "Unknown",
          expression2: "Unknown",
          phototag,
        })
        .catch(() => { })
    );
    // Waited for (max 10 s) so the notice shows before the candidate can click Resume.
    if (isResume) await verifyResumeIdentity(imageSrc);

    await axios
      .post("/test/savePrimaryImage", {
        headers: { "Access-Control-Allow-Origin": "*" },
        userid: examDetail[0].userid,
        userexamid: examDetail[0].id,
        instanceid: examDetail[0].instanceid,
        imagePath: primaryimage,
      })
      .then(() => {
        setShowProceedButton(true);
        setStartCapture(false);
        closeModal();
        setHidden(true);
        setMessage("Primary image successfully detected and uploaded!");
        setModal(true);
      })
      .catch((error) => {
        console.error("Error saving primary image:", error);
        setHidden(false);
        setMessage(
          error?.response?.data?.error ||
          "We couldn't save your photo. Check your internet connection, then refresh the page and try again."
        );
        setModal(true);
        // Let the candidate retake the photo rather than being stuck
        // with no way forward.
        setClickAgain(true);
        setShowClickAgainButton(true);
      });
  };

  // Compares the resume photo with the one taken at the start (server side, same face match as
  // the exam photos). Never blocks: only a completed comparison that clearly doesn't match shows
  // the notice; errors and unclear results say nothing.
  const verifyResumeIdentity = (imageSrc) =>
    axios
      .post("/test/proctoring/verify-resume", { userexamid: examDetail[0].id, currentImage: imageSrc.split(",")[1] }, { timeout: 10000 })
      .then((resp) => {
        if (resp.data && resp.data.checked === true && resp.data.match === false) setResumeIdentityNotice(true);
      })
      .catch(() => { });

  const clickAgain = async () => {
    setProctoringImageAnalysisLogId(null)
    await setCapturedImage(null);
    setClickAgain(false);
    setShowCaptureImageButton(true);
  };

  const proceed = () => {
    setHidden(true);
    setMessage(msgConstants.PROCEED_MSG);
    setModal(true);
    setCountFace(0);
    resumeTest();
  };

  const closeModal = () => {
    setClosed(true);
    setModalOpen(false);
    setCapturedImage(null);
  };

  const _saveImage = () => {
    setInCaptureMode(true);
    setModalOpen(true);
  };

  useEffect(() => {
    if (webcamRef.current) {
      setWebcamReady(true);
    }
  }, [webcamRef]);

  // Motion check pictures while the camera preview is up (no photo taken yet); a retake starts afresh.
  useEffect(() => {
    if (capturedImage !== null) return undefined;
    motionFramesRef.current = [];
    const timer = setInterval(() => {
      const video = webcamRef.current && webcamRef.current.video;
      if (!video || video.readyState < 2 || !video.videoWidth) return;
      try {
        const scale = Math.min(1, MOTION_LONG_SIDE / Math.max(video.videoWidth, video.videoHeight));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(video.videoWidth * scale);
        canvas.height = Math.round(video.videoHeight * scale);
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        motionFramesRef.current = [...motionFramesRef.current, canvas.toDataURL("image/jpeg", 0.8).split(",")[1]].slice(-MOTION_FRAMES);
      } catch (_err) {
        // logged only: no pictures just means no motion check
      }
    }, MOTION_FRAME_MS);
    return () => clearInterval(timer);
  }, [capturedImage]);

  const handleUserMediaError = (_err) => {
    setWebCamError(true);
  };

  const onCameraLoad = () => {
    setShowCaptureImageButton(true);
  };

  const goback = () => {
    window.onbeforeunload = function () {
      return null;
    };
    window.location.reload("/dashboard");
  };

  const onConfirm = () => {
    setMediaErrorModal(false);
  };

  const onCamTroubleshoot = () => {
    setCameraTroubleshoot(true);
  };

  const onMicTroubleshoot = () => {
    setMicTroubleshoot(true);
  };

  const isSuccessMessage =
    message === "Primary image successfully detected and uploaded!" ||
    message === "Webcam has been configured successfully.  Click on Start / Resume to continue..." ||
    message === msgConstants.PROCEED_MSG;

  return (
    <>
      {examDetail[0].test_type === "14" || examDetail[0].test_type === "15" ? (
        <div>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            {snapShow === true ? (
              StartCapture === true ? (
                <Button variant="contained" color="primary" onClick={startCapture}>
                  <strong>Start</strong>
                </Button>
              ) : (
                <Button variant="contained" color="primary" onClick={proceed}>
                  <strong>Proceed further</strong>
                </Button>
              )
            ) : (hidden && examDetail[0].monitoringflag) || true ? (
              <Button variant="contained" style={{ marginLeft: "2rem" }} color="primary" onClick={() => resumeTest()}>
                <strong>{examDetail[0].status === "000" ? "Start" : "Resume"}</strong>
              </Button>
            ) : StartCapture === true ? (
              <Button variant="contained" color="primary" onClick={startCapture}>
                <strong>Start</strong>
              </Button>
            ) : (
              <Button variant="contained" color="primary" onClick={proceed}>
                <strong>Proceed further</strong>
              </Button>
            )}
          </Grid>
          <Dialog fullScreen open={modalOpen} onClose={closeModal} disableBackdropClick disableEscapeKeyDown slots={{ transition: Transition }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: "20px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "800px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  padding: "32px",
                  border: "solid 1px",
                  borderColor: "#808080",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                {testingStage === "mic" ? (
                  <div>
                    <Typography variant="h6" align="center" gutterBottom>
                      <b>Audio setup</b>
                    </Typography>
                    <Typography align="center" style={{ marginBottom: "24px" }}>
                      Microphone access is mandatory for this Assessment.
                      <br />
                      Make sure that your microphone is on throughout the assessment.
                    </Typography>

                    {micNeeded ? (
                      <AudioTest
                        onTestComplete={(success) => {
                          setMicError(!success);
                          if (success) {
                            setTestingStage("camera");
                          }
                        }}
                      />
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <div style={{ marginBottom: "24px" }}>
                          <strong>There is No need of Microphone for this test</strong>
                        </div>
                        <img
                          src={noMicrophone}
                          alt="No Microphone"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            marginBottom: "24px",
                          }}
                        />
                        <Button variant="contained" color="primary" onClick={() => setTestingStage("camera")}>
                          Continue to Camera Setup
                        </Button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <Typography variant="h6" align="center" gutterBottom>
                      <b>Camera setup</b>
                    </Typography>
                    <Typography align="center" style={{ marginBottom: "24px" }}>
                      We use camera images to ensure fairness for everyone.
                      <br />
                      Make sure that you are in front of your camera.
                    </Typography>

                    {capturedImage === null && (
                      <div
                        style={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          padding: "24px",
                          marginBottom: "24px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "16px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <VideocamIcon />
                            <Typography variant="h6" style={{ marginLeft: "8px" }}>
                              <b>Camera</b>
                            </Typography>
                            <ArrowRightAltIcon style={{ marginLeft: "8px" }} />
                          </div>
                          <div style={{ display: "flex" }}>
                            <Typography style={{ marginRight: "8px" }}>{!WebCamError ? "Enabled" : "Disabled"}</Typography>
                            {!WebCamError ? <CheckCircleIcon style={{ color: "#00FF00" }} /> : <CancelIcon style={{ color: "#FF0000" }} />}
                          </div>
                        </div>

                        {!WebCamError ? (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              marginBottom: "16px",
                            }}
                          >
                            <Webcam
                              ref={webcamRef}
                              onUserMedia={onCameraLoad}
                              onUserMediaError={handleUserMediaError}
                              videoConstraints={REFERENCE_CAMERA_CONSTRAINTS}
                              forceScreenshotSourceSize
                              screenshotFormat="image/png"
                              style={{
                                width: "100%",
                                maxWidth: "550px",
                                height: "auto",
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              backgroundColor: "#f5f5f5",
                              padding: "24px",
                              borderRadius: "4px",
                            }}
                          >
                            <Typography variant="h6" gutterBottom>
                              <b>Trouble with your webcam?</b>
                            </Typography>
                            <Typography component="div">
                              <ul
                                style={{
                                  paddingLeft: "20px",
                                  margin: "16px 0",
                                }}
                              >
                                <li>Ensure you have granted permission for your browser to access your camera.</li>
                                <li>
                                  Ensure you are using a <b>supported browser</b>.
                                </li>
                                <li>If you have multiple camera devices, ensure you have given your browser permission to use the right device.</li>
                                <li>Ensure your camera driver and web browser is up to date.</li>
                                <li>Restart your device and try accessing the assessment again.</li>
                              </ul>
                            </Typography>
                          </div>
                        )}
                      </div>
                    )}

                    <div style={{ textAlign: "center" }}>
                      {!WebCamError ? (
                        processing ? (
                          <div style={{ marginTop: "16px" }}>
                            <CircularProgress />
                            <Typography style={{ marginTop: "8px" }}>Processing image, please wait...</Typography>
                          </div>
                        ) : showProceedButton ? null : ClickAgain ? (
                          DeviceNotSupported ? (
                            <Typography style={{ marginBottom: "16px" }}>
                              <b>{msgConstants.DEVICE_NOT_SUPPORTED_MSG}</b>
                            </Typography>
                          ) : (
                            ShowClickAgainButton && (
                              <div>
                                <Typography style={{ marginBottom: "16px" }}>
                                  {SystemNotReady ? (
                                    <b>{msgConstants.SYSTEM_NOT_READY_MSG}</b>
                                  ) : Nofaces ? (
                                    <b>{cameraUnavailable ? msgConstants.CAMERA_UNAVAILABLE_MSG : cameraBlank ? msgConstants.CAMERA_BLANK_MSG : msgConstants.NOFACE_MSG}</b>
                                  ) : Multiplefaces ? (
                                    <b>{msgConstants.MULTIFACE_MSG}</b>
                                  ) : notFacingCamera ? (
                                    <b>{msgConstants.NOT_FACING_MSG}</b>
                                  ) : handObstruction ? (
                                    <b>{msgConstants.HAND_OBSTRUCTION_MSG}</b>
                                  ) : faceOccluded ? (
                                    <b>{msgConstants.FACE_OCCLUDED_MSG}</b>
                                  ) : spoofSuspected ? (
                                    <b>{msgConstants.REFERENCE_SPOOF_MSG}</b>
                                  ) : faceUnclear ? (
                                    <b>{msgConstants.FACE_UNCLEAR_MSG}</b>
                                  ) : ObjectsDetected ? (
                                    <b>{msgConstants.OBJECTS_DETECTED_MSG}</b>
                                  ) : null}
                                </Typography>
                                {proctoringImageAnalysisLogId && (
                                  <Typography style={{ marginBottom: "16px" }}>
                                    <b>(Analysis ID: {proctoringImageAnalysisLogId})</b>
                                  </Typography>
                                )}
                                <Button variant="contained" color="primary" onClick={clickAgain}>
                                  <strong>Click Again</strong>
                                </Button>
                              </div>
                            )
                          )
                        ) : (
                          <Button variant="contained" color="primary" onClick={captureImage}>
                            <strong>Capture Image</strong>
                          </Button>
                        )
                      ) : (
                        <Button variant="contained" color="primary" onClick={onCamTroubleshoot}>
                          <strong>Troubleshoot</strong>
                        </Button>
                      )}
                    </div>

                    {WaitingMessage && (
                      <Typography align="center" style={{ marginTop: "16px", color: "#555" }}>
                        {WaitingMessage}
                      </Typography>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Dialog>
        </div>
      ) : (
        <div>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            {snapShow === true ? (
              StartCapture === true ? (
                <Button variant="contained" color="primary" onClick={startCapture}>
                  <strong>Start</strong>
                </Button>
              ) : (
                <Button variant="contained" color="primary" onClick={proceed}>
                  <strong>Proceed further</strong>
                </Button>
              )
            ) : (hidden && examDetail[0].monitoringflag) || true ? (
              <Button variant="contained" style={{ marginLeft: "2rem" }} color="primary" onClick={() => resumeTest()}>
                <strong>{examDetail[0].status === "000" ? "Start" : "Resume"}</strong>
              </Button>
            ) : StartCapture === true ? (
              <Button variant="contained" color="primary" onClick={startCapture}>
                <strong>Start</strong>
              </Button>
            ) : (
              <Button variant="contained" color="primary" onClick={proceed}>
                <strong>Proceed further</strong>
              </Button>
            )}
          </Grid>
          <Dialog fullScreen open={modalOpen} onClose={closeModal} disableBackdropClick disableEscapeKeyDown slots={{ transition: Transition }}>
            <Grid>
              {MonitoringData && MonitoringData.result && MonitoringData.result.speaker_dialect && WebCamError && MicError && (
                <Modal
                  open={MediaErrorModal}
                  disableEnforceFocus={true}
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.modal}
                  closeAfterTransition
                  slots={{ backdrop: Backdrop }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }}
                >
                  <Fade in={MediaErrorModal}>
                    <div className={classes.paper} style={{ textAlign: "justify" }}>
                      <h3 id="transition-modal-title" style={{ color: "#6f2981", marginBottom: "30px", textAlign: "center" }}>
                        Media Error
                      </h3>
                      <p id="transition-modal-description">
                        Web cam / Microphone access is mandatory for this Assessment. We regret to inform you that you cannot proceed ahead with the
                        test!
                      </p>
                      <div style={{ display: "flex", justifyContent: "space-around" }}>
                        <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                          Ok
                        </button>
                      </div>
                    </div>
                  </Fade>
                </Modal>
              )}
              {!CameraTroubleshoot && !MicTroubleshoot && WaitingMessage === null && (
                <Grid container rowSpacing={1}>
                  <Grid item xs={6} className={classes.leftColumn}>
                    <div className={classes.setup}>
                      <Typography variant="h6">
                        <b>Camera setup</b>
                      </Typography>
                      <Typography>
                        <br />
                        We use camera images to ensure fairness for everyone.
                        <br />
                        Make sure that you are in front of your camera.
                      </Typography>
                    </div>
                    {capturedImage === null && (
                      <div className={classes.webbox}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <VideocamIcon />
                            <Typography variant="h6" style={{ marginLeft: "8px" }}>
                              <b>Camera</b>
                            </Typography>
                            <ArrowRightAltIcon style={{ marginLeft: "8px", marginTop: "2px" }} />
                          </div>
                          {!WebCamError ? (
                            <div className={classes.leftstatus}>
                              <p style={{ marginTop: "17px" }}>Enabled</p>
                              <CheckCircleIcon style={{ marginBottom: "8px", color: "#00FF00" }} />
                            </div>
                          ) : (
                            <div className={classes.leftstatus}>
                              <p style={{ marginTop: "17px" }}>Disabled</p>
                              <CancelIcon style={{ marginBottom: "8px", color: "#FF0000" }} />
                            </div>
                          )}
                        </div>
                        {!WebCamError ? (
                          <div className={classes.WebCAM}>
                            <Webcam
                              ref={webcamRef}
                              onUserMedia={onCameraLoad}
                              onUserMediaError={handleUserMediaError}
                              videoConstraints={REFERENCE_CAMERA_CONSTRAINTS}
                              forceScreenshotSourceSize
                              screenshotFormat="image/png"
                              className={classes.camscreen}
                            />
                          </div>
                        ) : (
                          <div className={classes.background2}>
                            <Typography className={classes.box}>
                              <Typography variant="h6">
                                <b>Trouble with your webcam?</b>
                              </Typography>
                              Ensure you have granted permission for your browser to access your camera.
                              <br />
                              Ensure you are using a <b className={classes.browser}>supported browser</b>.
                              <br />
                              If you have multiple camera devices, ensure you have given your browser and our website permission to use the right
                              device.
                              <br />
                              Ensure your camera driver and web browser is up to date.
                              <br />
                              Restart your device and try accessing the assessment again using login credentials shared with you.
                            </Typography>
                          </div>
                        )}
                        {WebCamError && (
                          <p style={{ marginLeft: "20px", marginTop: "12px", marginRight: "20px" }}>
                            To enable access you can check some solutions by clicking on below 'Troubleshoot' button.
                          </p>
                        )}
                      </div>
                    )}
                    {!WebCamError ? (
                      showProceedButton ? (
                        closeModal
                      ) : ClickAgain ? (
                        DeviceNotSupported ? (
                          <div className={classes.clickAgainTXT}>
                            <Typography>
                              <br />
                              <br />
                              <b>{msgConstants.DEVICE_NOT_SUPPORTED_MSG}</b>
                            </Typography>
                          </div>
                        ) : (
                          ShowClickAgainButton && (
                            <div className={classes.clickAgainTXT}>
                              <Typography>
                                <br />
                                <br />
                                {SystemNotReady ? (
                                  <b>{msgConstants.SYSTEM_NOT_READY_MSG}</b>
                                ) : Nofaces ? (
                                  <b>{cameraUnavailable ? msgConstants.CAMERA_UNAVAILABLE_MSG : cameraBlank ? msgConstants.CAMERA_BLANK_MSG : msgConstants.NOFACE_MSG}</b>
                                ) : Multiplefaces ? (
                                  <b>{msgConstants.MULTIFACE_MSG}</b>
                                ) : notFacingCamera ? (
                                  <b>{msgConstants.NOT_LOOKING_MSG}</b>
                                ) : handObstruction ? (
                                  <b>{msgConstants.HAND_OBSTRUCTION_MSG}</b>
                                ) : faceOccluded ? (
                                  <b>{msgConstants.FACE_OCCLUDED_MSG}</b>
                                ) : spoofSuspected ? (
                                  <b>{msgConstants.REFERENCE_SPOOF_MSG}</b>
                                ) : faceUnclear ? (
                                  <b>{msgConstants.FACE_UNCLEAR_MSG}</b>
                                ) : ObjectsDetected ? (
                                  <b>{msgConstants.OBJECTS_DETECTED_MSG}</b>
                                ) : null}
                              </Typography>
                              {proctoringImageAnalysisLogId && (
                                <Typography style={{ marginBottom: "16px" }}>
                                  <b>(Analysis ID: {proctoringImageAnalysisLogId})</b>
                                </Typography>
                              )}
                              <div className={classes.captureBTN}>
                                <Button variant="contained" color="primary" onClick={clickAgain}>
                                  <strong>Click Again</strong>
                                </Button>
                              </div>
                            </div>
                          )
                        )
                      ) : !MicError ? (
                        ShowCaptureImageButton && (
                          <div className={classes.captureBTN}>
                            <div className={classes.BTN}>
                              <Button className="mt-2" variant="contained" color="primary" onClick={captureImage}>
                                <strong>Capture Image</strong>
                              </Button>
                            </div>
                          </div>
                        )
                      ) : (
                        <strong className={classes.accessmic}>Please enable access for microphone then you will capture the image.</strong>
                      )
                    ) : (
                      <div className={classes.captureBTN}>
                        <div className={classes.BTN}>
                          <Button className="mt-2" variant="contained" color="primary" onClick={onCamTroubleshoot}>
                            <strong>Troubleshoot</strong>
                          </Button>
                        </div>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    {MonitoringData && MonitoringData.result && MonitoringData.result.speaker_dialect ? (
                      <div className={classes.rightsetup}>
                        <Typography variant="h6">
                          <b>Audio setup</b>
                        </Typography>
                        <Typography>
                          <br />
                          We use microphone to ensure fairness for the entire assessment.
                          <br />
                          Make sure that your microphone is on throughout the assessment.
                        </Typography>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <MicIcon />
                            <Typography variant="h6" style={{ marginLeft: "8px" }}>
                              <b>Audio:</b>
                            </Typography>
                            <ArrowRightAltIcon style={{ marginLeft: "8px", marginTop: "2px" }} />
                          </div>
                          {!MicError ? (
                            <div className={classes.leftstatus}>
                              <p style={{ marginTop: "17px" }}>Enabled</p>
                              <CheckCircleIcon style={{ marginBottom: "8px", color: "#00FF00" }} />
                            </div>
                          ) : (
                            <div className={classes.leftstatus}>
                              <p style={{ marginTop: "17px" }}>Disabled</p>
                              <CancelIcon style={{ marginBottom: "8px", color: "#FF0000" }} />
                            </div>
                          )}
                        </div>
                        {MicError ? (
                          <div className={classes.background2}>
                            <Typography className={classes.box}>
                              <Typography variant="h6">
                                <b>Trouble with your microphone?</b>
                              </Typography>
                              Ensure you have granted permission for your browser to access your microphone.
                              <br />
                              Confirm that you are using a <b className={classes.browser}>supported browser</b>.
                              <br />
                              If you have multiple microphone devices, make sure you have given your browser and our website permission to use the
                              correct microphone.
                              <br />
                              Ensure your microphone driver and web browser is up to date.
                              <br />
                              Restart your device and try accessing the assessment again using login credentials shared with you.
                            </Typography>
                          </div>
                        ) : (
                          <div className={classes.box}>
                            <Typography>
                              {" "}
                              Your microphone is working <strong>perfectly</strong>.{" "}
                            </Typography>
                            {!WebCamError ? (
                              <Typography style={{ width: "80%" }} className={classes.box}>
                                {" "}
                                <br />
                                Just be stable and make sure that your face is <strong>perfectly fitting</strong> in camera and then click on{" "}
                                <strong>CAPTURE IMAGE</strong> button.{" "}
                              </Typography>
                            ) : (
                              <Typography style={{ width: "80%" }} className={classes.box}>
                                {" "}
                                But there is problem with accessing your <strong>webcam</strong>. Please resolve that issue. (you can follow left side
                                instructions to fix this.)
                              </Typography>
                            )}
                          </div>
                        )}
                        {MicError && (
                          <p style={{ marginLeft: "26px", marginTop: "12px" }}>
                            To enable access you can check some solutions by clicking on below 'Troubleshoot' button.
                          </p>
                        )}
                        {MicError && (
                          <div className={classes.audiobottombutton}>
                            <div className={classes.captureBTN}>
                              <div className={classes.BTN}>
                                <Button className="mt-2" variant="contained" color="primary" onClick={onMicTroubleshoot}>
                                  <strong>Troubleshoot</strong>
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <Grid container spacing={0}>
                        <Grid item sm={12}>
                          <div className={classes.nomic}>
                            <strong>There is No need of Microphone for this test</strong>
                          </div>
                        </Grid>
                        <Grid item className={classes.micimage} sm={12}>
                          <img src={noMicrophone} alt="No Microphone" style={{ maxWidth: "100%", height: "auto" }} />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}
              {CameraTroubleshoot && WaitingMessage === null && (
                <Grid>
                  <Grid item xs={11}>
                    <div>
                      <div className={classes.wrapper}>
                        <div style={{ display: "flex", alignItems: "center" }} className={classes.leftColumn}>
                          <VideocamIcon />
                          <Typography variant="h6" style={{ marginLeft: "8px" }}>
                            <b>Camera:</b>
                          </Typography>
                        </div>
                        <div className={classes.TopRightColumn}>
                          <Button className="mt-2" variant="contained" color="primary" onClick={goback}>
                            <strong>Back</strong>
                          </Button>
                        </div>
                      </div>
                      <div className={classes.Errwrapper}>
                        <div className={classes.ErrleftColumn}>
                          <div className={classes.weberror}>
                            <ErrorOutlineOutlinedIcon />
                            <strong>Error Message: Looks like your webcam is NOT working.</strong>
                          </div>
                          <p>There could be several reasons for this issue:</p>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={10} className={classes.errWebCAM}>
                    <div className={classes.errWebCAMPara}>
                      <p>
                        <strong>Reasons:</strong>
                      </p>
                      <ol>
                        <li>
                          <strong>Blocked Access: </strong>The access to your webcam might be blocked by your browser.
                        </li>
                        <li>
                          <strong>Loose Connection:</strong> Make sure that the camera is securely plugged into your computer or mobile device.
                        </li>
                        <li>
                          <strong>USB Port:</strong> If you have more than one USB port, try plugging the camera into a different one, as the current
                          port might be malfunctioning.
                        </li>
                      </ol>
                      <br />
                      <p>
                        <em>
                          <strong>To resolve "Blocked Access", follow the steps below:</strong>
                        </em>
                      </p>
                      <ol>
                        <li>
                          Refresh the Page: If access to the webcam is blocked, refresh the page and check if your browser is asking for access. If it
                          does, enable it by clicking on the "Allow" button.
                        </li>
                        <li>
                          Using Lock Icon (Top-Left Corner):
                          <ol>
                            <li>Check the top-left corner of your browser screen. You should see a small lock-like icon before the website name.</li>
                            <li>Click on it, and a dropdown menu will appear. In this menu, look for camera access permissions.</li>
                            <li>Allow camera access for this website. It may look like this: Allow Camera</li>
                            <li>After allowing access, refresh the page by clicking on top-right corner 'BACK' button.</li>
                          </ol>
                        </li>
                        <li>
                          Using Camera Icon (Top-Right Corner):
                          <ol>
                            <li>
                              Check the top-right corner of your browser screen for a camera icon. If it looks like Blocked Camera Icon, it means your
                              camera access is blocked.
                            </li>
                            <li>Click on this camera icon.</li>
                            <li>A dialog box will open, showing camera access permissions. If it's blocked, please select: Allow Camera.</li>
                            <li>Once access is granted, refresh the page by clicking on top-right corner 'BACK' button.</li>
                          </ol>
                        </li>
                      </ol>
                      <br />
                      <p>
                        <b>
                          If you've followed these steps and your webcam is still not working, it might be a hardware issue. In that case, consider
                          using an external webcam or contacting technical support for further assistance.
                        </b>
                      </p>
                    </div>
                  </Grid>
                </Grid>
              )}
              {MicTroubleshoot && WaitingMessage === null && (
                <Grid>
                  <Grid item xs={11}>
                    <div>
                      <div className={classes.wrapper}>
                        <div style={{ display: "flex", alignItems: "center" }} className={classes.leftColumn}>
                          <MicIcon />
                          <Typography variant="h6" style={{ marginLeft: "8px" }}>
                            <b>Microphone:</b>
                          </Typography>
                        </div>
                        <div className={classes.TopRightColumn}>
                          <Button className="mt-2" variant="contained" color="primary" onClick={goback}>
                            <strong>Back</strong>
                          </Button>
                        </div>
                      </div>
                      <div className={classes.Errwrapper}>
                        <div className={classes.ErrleftColumn}>
                          <div className={classes.micerror}>
                            <ErrorOutlineOutlinedIcon />
                            <strong>Error Message: Looks like your Microphone is NOT working.</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={10} className={classes.errWebCAM}>
                    <div className={classes.errWebCAMPara}>
                      <p>
                        <strong>Trouble with your microphone?</strong>
                      </p>
                      <ol>
                        <li>
                          <p>
                            <strong>Permission Settings:</strong> Ensure you have granted permission for your browser to access your microphone.
                            Follow these steps:
                          </p>
                          <ul>
                            <li>Click on the lock or information icon in the address bar (usually on the left side).</li>
                            <li>Find the microphone option and make sure it's set to "Allow" or "Ask (default)."</li>
                          </ul>
                          <br />
                        </li>
                        <li>
                          <p>
                            <strong>Supported Browser:</strong> Confirm that you are using a supported browser for the assessment. We recommend using
                            the latest version of browsers like Google Chrome, Mozilla Firefox, or Microsoft Edge for optimal performance.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>Select the Right Microphone:</strong> If you have multiple microphone devices, make sure you have given your
                            browser and our website permission to use the correct microphone. Follow these steps:
                          </p>
                          <ul>
                            <li>Click on the lock or information icon in the address bar.</li>
                            <li>Look for the microphone settings and select the appropriate device.</li>
                          </ul>
                          <br />
                        </li>
                        <li>
                          <p>
                            <strong>Update Microphone Driver:</strong> Ensure your microphone driver is up to date. Outdated drivers can cause
                            compatibility issues. Visit the device manager on your computer and update the microphone driver if necessary.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>Browser Update:</strong> Make sure your web browser is up to date. An outdated browser may not fully support the
                            latest features, including microphone access. Check for updates and install them if available.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>Restart Your Device:</strong> Sometimes, a simple restart can resolve microphone issues. Restart your computer or
                            device and try accessing the assessment again using the provided login credentials.
                          </p>
                        </li>
                      </ol>
                    </div>
                  </Grid>
                </Grid>
              )}

              <Grid item xs={12}>
                {WaitingMessage !== null && (
                  <div>
                    <div className={classes.waitMSG}>
                      <strong>{WaitingMessage}</strong>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          </Dialog>
        </div>
      )}
      <Dialog open={resumeIdentityNotice} disableEscapeKeyDown maxWidth="sm" fullWidth style={{ zIndex: 100000 }}>
        <div style={{ padding: "24px 28px" }}>
          <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>
            {msgConstants.RESUME_IDENTITY_TITLE}
          </Typography>
          <Typography variant="body1" style={{ lineHeight: 1.6, marginBottom: 20 }}>
            {msgConstants.RESUME_IDENTITY_NOTICE}
          </Typography>
          <div style={{ textAlign: "right" }}>
            <Button variant="contained" color="primary" onClick={() => setResumeIdentityNotice(false)}>
              I understand, continue
            </Button>
          </div>
        </div>
      </Dialog>
      <Snackbar
        open={modal}
        // Errors stay up until the candidate dismisses them (via the Alert's
        // close icon) instead of auto-hiding after 2s - they need time to
        // read actionable text like "check your connection" before retrying.
        autoHideDuration={isSuccessMessage ? 2000 : null}
        onClose={handleClose}
        slots={{ transition: FadeTransition }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity={isSuccessMessage ? "success" : "error"}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
export default ImagEProctoringCapture;
